"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Cookies_1 = tslib_1.__importDefault(require("../util/Cookies"));
const RestUtils_1 = tslib_1.__importDefault(require("./RestUtils"));
const URLPrefixMap_1 = tslib_1.__importDefault(require("./URLPrefixMap"));
class SharedSecret {
    static getSharedSecretName() {
        return SharedSecret.SHARED_SECRET;
    }
    static getSharedSecretValue(url, loginId, moveCookieToHostPageBaseUrl = true) {
        this.handleSharedSecretCookie(moveCookieToHostPageBaseUrl);
        const path = RestUtils_1.default.extractPathFromUrl(url);
        this.restoreSharedSecrets();
        let secret = this.secrets.get(path);
        if (loginId) {
            secret += `:${loginId}`;
        }
        // This is a hack, since this.secrets.get can return undefined
        return secret;
    }
    /**
     * Shared secret cookies are received with the path specified as "/" and
     * with the name "SharedSecret-" + contextPath. Remove the cookie and create
     * a new one named "SharedSecret" with path set to the context path.
     * @throws InconsistentLoginIdException
     */
    static handleSharedSecretCookie(moveCookieToHostPageBaseUrl) {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            if (cookie.startsWith("SharedSecret-")) {
                const idx = cookie.indexOf("=");
                const name = cookie.substring(0, idx);
                const secret = cookie.substring(idx + 1);
                const path = "/" + name.substring(13);
                this.secrets.put(path, secret);
                // Move cookie to a path that is as specific as possible to
                // limit the number of requests where it will be send. At the
                // same time, the path must be readable by this application.
                const newPath = moveCookieToHostPageBaseUrl ? RestUtils_1.default.getHostPageBaseURL() : "/";
                const newName = "_" + name;
                this.moveCookie(name, "/", newName, newPath, secret);
            }
        }
    }
    static restoreSharedSecrets() {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            if (cookie.startsWith("_SharedSecret-")) {
                const idx = cookie.indexOf("=");
                const name = cookie.substring(0, idx);
                const secret = cookie.substring(idx + 1);
                const path = "/" + name.substring(14);
                this.secrets.put(path, secret);
            }
        }
    }
    static moveCookie(oldName, oldPath, newName, newPath, value) {
        // Remove cookie with original path and name
        Cookies_1.default.removeCookie(oldName, oldPath);
        // Add cookie with new path and name
        document.cookie = `${newName}=${value};path=${newPath}` + (SharedSecret.isSessionSecure() ? ";secure" : "");
    }
    static isSessionSecure() {
        return document.URL.startsWith("https");
    }
}
SharedSecret.SHARED_SECRET = "SharedSecret";
SharedSecret.secrets = new URLPrefixMap_1.default();
exports.default = SharedSecret;
//# sourceMappingURL=SharedSecret.js.map